import { useEffect, useState } from "react";
import { getNodes } from "@utils/getNodes";
import { Shopify } from "@models/shopify.model";
import LineItem from "./line-item";
import SubTotals from "./sub-totals";
import Total from "./total";
import { OrderSummaryProps } from "./OrderSummary.model";
import * as Styled from "./OrderSummary.styled";
import { AccountHeader } from "../Account.styled";

const calculateItemDiscounts = (items: Shopify.OrderLineItem[]) =>
  items.reduce((_total, item) => {
    const { discountAllocations } = item;

    const discounts = discountAllocations.reduce(
      (_discountTotal, discount) => _discountTotal + parseFloat(discount.allocatedAmount.amount),
      0
    );

    return _total + discounts;
  }, 0);

const calculateShippingDiscounts = (discounts: Shopify.DiscountAllocation[]) =>
  discounts.reduce((_total, discount) => _total + parseFloat(discount.allocatedAmount.amount), 0);

const OrderSummary = ({ order, membershipModal, shadowPrices }: OrderSummaryProps) => {
  const { discountApplications, lineItems, shippingDiscountAllocations } = order;
  const items = getNodes<Shopify.OrderLineItem>(lineItems);
  // TO DO: MIR-1019: Remove hasBundle and useEffect when custom order attributes are added.
  const [hasBundle, setHasBundle] = useState(false);

  useEffect(() => {
    if (items?.length > 0) {
      const bundleItem = items.find((item) => item.variant?.product?.tags?.includes("bundle"));

      if (bundleItem) setHasBundle(true);
    }
  }, [items]);

  // TO DO: MIR-741: Tackle Promotions
  const totalLineItemDiscounts = calculateItemDiscounts(items);
  const totalShippingDiscounts = calculateShippingDiscounts(shippingDiscountAllocations);
  const totalOrderDiscounts = 0;
  const savingsTotal = totalLineItemDiscounts + totalShippingDiscounts + totalOrderDiscounts;

  return (
    <>
      <Styled.Summary>
        <AccountHeader>
          <h3>Order Summary</h3>
        </AccountHeader>
        <main>
          {items.length > 0 && (
            <ul className="line-items">
              {items.map(
                (item, idx) =>
                  // TO DO: MIR-1019: Update conditional when custom order attributes are added.
                  (item.discountedTotalPrice?.amount !== "0.0" ||
                    item.variant?.product?.tags?.includes("membership")) && (
                    <LineItem
                      key={idx}
                      item={item}
                      membershipModal={membershipModal}
                      shadowPrices={shadowPrices}
                    />
                  )
              )}
            </ul>
          )}
        </main>
        <footer data-testid="savings-footer">
          <div className="checkout-footer">
            <SubTotals
              hasBundle={hasBundle}
              order={order}
              shadowPrices={shadowPrices}
              totalLineItemDiscounts={totalLineItemDiscounts}
              totalShippingDiscounts={totalShippingDiscounts}
              totalOrderDiscounts={totalOrderDiscounts}
            />
            <Total
              hasBundle={hasBundle}
              className={"show-for-medium"}
              orderTotal={order.totalPrice.amount}
              savings={savingsTotal}
              shadowPrices={shadowPrices}
            />
          </div>
          {/* TO DO: MIR-741: Tackle Promotions */}
          {/* {savingsTotal > 0 && (
            <Savings
              className={"show-for-medium"}
              savings={savingsTotal}
              shadowPrices={shadowPrices}
            />
          )} */}
        </footer>
      </Styled.Summary>
    </>
  );
};

export default OrderSummary;
